import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const EditIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M5.78263 14.6803L8.88698 17.7784L18.2004 8.4837L15.0957 5.3856L5.78263 14.6803ZM5.00016 18.5528L8.31982 18.3209L5.2151 15.222L5.00016 18.5528ZM19.2705 5.87011L17.718 4.32088C17.512 4.11539 17.2329 4 16.9419 4C16.6509 4 16.3718 4.11539 16.1658 4.32088L15.8712 4.61116L18.9756 7.70927L19.2702 7.41898C19.3721 7.31742 19.453 7.19674 19.5082 7.06386C19.5634 6.93098 19.5918 6.78851 19.5919 6.64462C19.5919 6.50073 19.5635 6.35825 19.5084 6.22534C19.4532 6.09244 19.3724 5.97172 19.2705 5.87011Z"
        fill="#676767"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.0576 17.6636L5.90749 16.2028L6.05359 16.0591L8.31966 18.3208L5 18.5574L5.0576 17.6636ZM6.61044 15.5111L8.88695 17.783L18.2004 8.48836L15.9893 6.28204L6.61044 15.5111ZM16.7705 5.51334L18.9755 7.71393L19.2747 7.41909C19.3767 7.31753 19.4575 7.19685 19.5127 7.06397C19.5679 6.93109 19.5964 6.78862 19.5964 6.64473C19.5964 6.50084 19.5681 6.35836 19.5129 6.22545C19.4578 6.09254 19.377 5.97183 19.2751 5.87022L17.8515 4.44965L16.7705 5.51334Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(EditIcon);
